import { useAuth } from '../contexts/auth';
import { Navigate, Outlet } from 'react-router-dom';

type Props = {
  checkAdmin?: boolean;
}

export default function RouteGuard({ checkAdmin }: Props) {
  const { token, loggedUser } = useAuth();

  if (!token || (checkAdmin && loggedUser && !loggedUser.realmAdmin)) return <Navigate to="/login" />

  return <Outlet />;
}